import { axiosInstance } from "@/axios.instance";
import { AxiosInstance } from "axios";

const SitRepCsvRoute = "/Report/Incident";

class SitRepCsvApi {
	private axios: AxiosInstance;

	constructor() {
		this.axios = axiosInstance;
	}

	public async GenerateSitRepCsv(eventID: number): Promise<{data: string, headers: { [key: string]: string }}> {
		return await this.axios.get(`${SitRepCsvRoute}/SitRepCsv/${eventID}`);
	}
}

const sitRepCsvApi = new SitRepCsvApi();
export default sitRepCsvApi;
